<template>
    <div class="container nopadding">
        <div class="wrapper">
            <div class="header"><h1>{{$t('layout_profilo_tooltip')}}</h1></div>
            <div class="content container" style="padding:50px 0;">
                <div class="row row-sezione" style="max-width:600px; margin:auto;">
                    <div class="col-md-6">
                        <router-link :to="{name:'user.edit'}" class="btn btn-app a2">
                            <i class="fas fa-pencil-alt"></i><br>{{$t('account.dati_utente')}}
                        </router-link>
                    </div>
                    <div class="col-md-6" v-if="this.f_stripe">
                        <router-link :to="{name: 'user.payments'}" class="btn btn-app a2">
                            <i class="fa fa-credit-card"></i><br>{{$t('metodi_pagamento_title')}}
                        </router-link>
                    </div>
                    <div class="col-md-6" v-if="this.locale_delivery_active">
                        <router-link :to="{name: 'user.addresses'}"
                                     class="btn btn-app a2">
                            <i class="fa fa-map-signs"></i><br>{{$t('account.gestione_indirizzi')}}
                        </router-link>
                    </div>
                    <div class="col-md-6">
                        <router-link :to="{name:'orders.history'}" class="btn btn-app a2">
                            <i class="fa fa-archive"></i><br>{{$t('account.storico_ordini')}}
                        </router-link>
                    </div>
                    <div class="col-md-6" v-if="this.enable_reservations">
                        <router-link :to="{name:'reservations.history'}" class="btn btn-app a2">
                            <i class="fa fa-calendar"></i><br>{{$t('account.prenotazioni')}}
                        </router-link>
                    </div>
                    <div class="col-md-6" v-for="checkbox in this.checkboxes">
                        <a href="#" class="btn btn-app a2" @click.prevent="openModal(checkbox)">
                            <i class="fa fa-gavel"></i><br>{{checkbox.label}}
                        </a>
                    </div>
                    <div class="col-12">
                        <a href="#" @click.prevent="handleLogout()"
                           class="btn btn-primary w-100">
                            <i class="fa fa-unlock mr-2"></i> Logout
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <modal v-if="this.show_modal" @close="show_modal = false" :show-title="true">
            <div slot="header">
                <h5 class="modal-title">{{this.current_checkbox.label}}</h5>
            </div>
            <div slot="body">
                <iframe :src="this.current_checkbox.url" class="w-100" style="height:500px;" frameBorder="0">
                    Browser not compatible
                </iframe>
            </div>
        </modal>
    </div>
</template>

<script>
import {mapGetters, mapState, mapActions} from 'vuex';
import {getPrivacyCheckboxes} from "../../api/restaurant";

import Modal from "../partials/Modal";
import router from "../../routes";

export default {
    name: "UserMenu",
    components: {Modal},
    data() {
        return {
            privacy_link: null,
            show_modal: false,
            checkboxes: [],
            current_checkbox: null
        };
    },
    created() {
        this.fetch();
    },
    computed: {
        ...mapGetters('restaurant', {
            locale_delivery_active: 'localeDeliveryActive',
            enable_reservations: 'enableReservations',
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale,
            f_stripe: state => state.f_stripe
        })
    },
    watch: {
        language: function () {
            this.fetch();
        }
    },
    methods: {
        fetch: function () {
            this.showLoading(true);
            getPrivacyCheckboxes(this.language, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id,
                for_general: true
            }).then((response) => {
                this.checkboxes = response.checkboxes;
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            }).finally(() => {
                this.showLoading(false);
            });
        },
        openModal: function (checkbox) {
            this.current_checkbox = checkbox;
            this.show_modal = true;
        },
        handleLogout: function () {
            this.removeUserData();
            router.replace('/');
        },
        ...mapActions('auth', [
            'removeUserData'
        ]),
        ...mapActions('global', [
            'showLoading'
        ])
    }
}
</script>
